import { j as i, a as l } from "../../../../../emotion-react-jsx-runtime.browser.esm-CsRinUqv.js";
import { I as a } from "../../../../../Icon-JAg1YL1p.js";
import { I as c } from "../../../../../FeatureFlagProvider-qH18cz-b.js";
import "react";
import "@ionic/react";
import { translate as n } from "../../../../string-table.js";
import "../../../../../react-paginate-Lh5zQzpz.js";
import { Section as p } from "../Section/Section.js";
import "../../../LoadingInterstitial/LoadingInterstitial.js";
import "../../../../contexts/DesignSystemProvider/DesignSystemProvider.js";
function E(t) {
  const {
    qualifications: r,
    isSwingHero: m,
    skillBuilderCompletedTasks: s = []
  } = t;
  return /* @__PURE__ */ i(p, {
    title: n("SUB_PROFILE_QUALIFICATIONS_HEADER"),
    children: /* @__PURE__ */ l("div", {
      css: {
        marginTop: 8
      },
      children: [m && /* @__PURE__ */ i(c, {
        leftIcon: /* @__PURE__ */ i(a, {
          name: "Swing Hero"
        }),
        content: `${n("SUB_PROFILE_CONTACT_SWING")} ${n("SUB_PROFILE_CONTACT_HERO")}`,
        hasDivider: !0
      }), r.map((e, o) => /* @__PURE__ */ i("div", {
        children: /* @__PURE__ */ i(c, {
          leftIcon: /* @__PURE__ */ i(a, {
            name: "Verified"
          }),
          content: /* @__PURE__ */ i("span", {
            children: e
          }),
          hasDivider: !0
        })
      }, `${o}-${e}`)), s.length > 0 && s.map((e, o) => /* @__PURE__ */ i("div", {
        children: /* @__PURE__ */ i(c, {
          leftIcon: /* @__PURE__ */ i(a, {
            name: "Lesson"
          }),
          content: `${I(e)} (${n("SUB_PROFILE_QUALIFICATIONS_SKILL_BUILDER_SUB_LABEL")})`,
          hasDivider: !0
        })
      }, `${o}-${e}`))]
    })
  });
}
function I(t) {
  return t === "lwc.skill-check/outro" ? "Lead With Confidence" : t.split(".")[0].split("-").map((r) => r.charAt(0).toUpperCase() + r.slice(1)).join(" ");
}
export {
  E as Qualifications,
  I as formatSkillName
};
